import { WhmAvatar, WhmBox } from "@securitize/reactjs-whm";
import { useState } from "react";

export default function TokenAvatar({
  tokenIcon,
  issuerLogo,
  networkIcon,
}: {
  tokenIcon: string;
  issuerLogo: string;
  networkIcon: string;
}) {
  const [tokenIconError, setTokenIconError] = useState(false);
  return (
    <WhmBox
      sx={{ position: "relative", marginTop: "6px", marginBottom: "6px" }}
    >
      <WhmAvatar
        src={tokenIconError ? issuerLogo : tokenIcon}
        sx={{
          width: "32px",
          height: "32px",
        }}
        onError={() => setTokenIconError(true)}
      />
      <WhmAvatar
        src={networkIcon}
        sx={{
          width: "18px",
          height: "18px",
          position: "absolute",
          top: "20px",
          left: "20px",
          border: (theme) => `1px solid ${theme.palette.background.paper}`,
        }}
      />
    </WhmBox>
  );
}
